import { render } from "./SubmittedReview.vue?vue&type=template&id=3e85431d&scoped=true&ts=true"
import script from "./SubmittedReview.vue?vue&type=script&lang=ts"
export * from "./SubmittedReview.vue?vue&type=script&lang=ts"

import "./SubmittedReview.vue?vue&type=style&index=0&id=3e85431d&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e85431d"]])

export default __exports__